import React, { useState } from 'react';
import { 
  Container, Paper, TextField, Typography, Button, 
  Icon, Box, IconButton, CircularProgress, Snackbar, Alert 
} from '@mui/material';
import { useTheme } from '@mui/material/styles';

const Contacts = () => {
  const theme = useTheme();
  const isDark = theme.palette.mode === 'dark';
  
  // Refined Color Palette
  const colors = {
    accentRed: '#ff0033',
    accentCyan: '#00ffff',
    inputBg: isDark ? '#161b22' : '#f0f0f0',
    borderColor: 'rgba(255, 0, 51, 0.3)',
    text: theme.palette.text.primary,
  };

  const [formData, setFormData] = useState({ name: '', email: '', message: '' });
  const [status, setStatus] = useState('idle'); // 'idle' | 'loading' | 'success' | 'error'

  const handleSubmit = async () => {
    if (!formData.name || !formData.email || !formData.message) {
      setStatus('error');
      return;
    }

    setStatus('loading');
    
    // Simulate API call
    try {
      await new Promise(resolve => setTimeout(resolve, 1500));
      console.log('Payload:', formData);
      setFormData({ name: '', email: '', message: '' });
      setStatus('success');
    } catch (e) {
      setStatus('error');
    }
  };

  // Shared input styles
  const inputStyle = {
    "& .MuiOutlinedInput-root": {
      fontFamily: "JetBrains Mono, monospace",
      color: colors.text,
      bgcolor: colors.inputBg,
      "& fieldset": { borderColor: colors.borderColor },
      "&:hover fieldset": { borderColor: colors.accentRed },
      "&.Mui-focused fieldset": { borderColor: colors.accentRed },
    }
  };

  return (
    <Box component="section" id="contact" sx={{ py: 10 }}>
      <Container maxWidth="md">
        <Typography variant="h2" sx={{ fontFamily: "JetBrains Mono", color: colors.accentRed, mb: 6, textAlign: "center" }}>
          <span style={{ color: colors.accentCyan }}>$</span> contact --init
        </Typography>

        <Paper sx={{ p: 4, border: `1px solid ${colors.borderColor}`, bgcolor: 'transparent' }}>
          {['name', 'email', 'message'].map((field, idx) => (
            <Box key={field} sx={{ mb: 3 }}>
              <Typography sx={{ fontFamily: "JetBrains Mono", color: colors.accentCyan, mb: 1, fontSize: '14px' }}>
                $ {field === 'message' ? 'cat > message.txt' : `echo "Your ${field}" >> contact.txt`}
              </Typography>
              <TextField
                fullWidth
                multiline={field === 'message'}
                rows={field === 'message' ? 6 : 1}
                placeholder={field.charAt(0).toUpperCase() + field.slice(1)}
                value={formData[field]}
                onChange={(e) => setFormData({ ...formData, [field]: e.target.value })}
                sx={inputStyle}
              />
            </Box>
          ))}

          <Button
            fullWidth
            variant="contained"
            disabled={status === 'loading'}
            onClick={handleSubmit}
            sx={{ bgcolor: colors.accentRed, py: 1.5, '&:hover': { bgcolor: '#cc0029' } }}
            startIcon={status === 'loading' ? <CircularProgress size={20} color="inherit" /> : <Icon>send</Icon>}
          >
            {status === 'loading' ? 'Sending...' : '$ send_message --now'}
          </Button>
        </Paper>
      </Container>

      <Snackbar open={status === 'success' || status === 'error'} autoHideDuration={6000} onClose={() => setStatus('idle')}>
        <Alert severity={status === 'success' ? 'success' : 'error'} sx={{ width: '100%' }}>
          {status === 'success' ? 'Message delivered successfully.' : 'Failed to send. Please check your inputs.'}
        </Alert>
      </Snackbar>
    </Box>
  );
};

export default Contacts;